{
  "version": 1,
  "asset_id": "41ef708c-6fbb-42f6-b1c3-c865fbaa7e1e",
  "project_id": "d3d6c30c-5e9b-4177-897c-1c6e2a8b33af",
  "url": "/__l5e/assets-v1/41ef708c-6fbb-42f6-b1c3-c865fbaa7e1e/quartacase.webp",
  "r2_key": "a/v1/d3d6c30c-5e9b-4177-897c-1c6e2a8b33af/41ef708c-6fbb-42f6-b1c3-c865fbaa7e1e/quartacase.webp",
  "original_filename": "quartacase.webp",
  "size": 50982,
  "content_type": "image/webp",
  "created_at": "2026-07-28T12:40:14Z"
}